import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tms',
  templateUrl: './tms.component.html',
  styleUrls: ['./tms.component.css']
})
export class TmsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
